// 관리자 — 이용도우미 챗봇 질문 통계 (자주 묻는 질문)
//  - 원시 집계: GET /admin/assistant/stats?days=N (건수/역할·화면·업체별/피드백/정확중복/👎/일별)
//  - AI 주제 군집화: POST /admin/assistant/cluster (버튼 클릭 시에만 — 재과금 방지), GET 은 캐시 조회
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

function Bar(props) {
  var pct = props.max > 0 ? Math.round((props.value / props.max) * 100) : 0;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
      <div style={{ width: props.labelW || 130, fontSize: 12, color: '#334155', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={props.label}>{props.label}</div>
      <div style={{ flex: 1, background: '#eef2f7', borderRadius: 6, height: 16, position: 'relative' }}>
        <div style={{ width: pct + '%', background: props.color || '#1B3A5C', height: '100%', borderRadius: 6, minWidth: props.value > 0 ? 3 : 0 }} />
      </div>
      <div style={{ width: 42, textAlign: 'right', fontSize: 12, fontWeight: 700, color: '#1f2937' }}>{props.value}</div>
    </div>
  );
}

function Card(props) {
  return (
    <div style={{ border: '1px solid #e5e9f0', borderRadius: 10, background: '#fff', padding: 14, marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: '#1B3A5C', marginBottom: 10 }}>{props.title}</div>
      {props.children}
    </div>
  );
}

function AdminFaqStats(props) {
  var showToast = props.showToast;
  var _days = useState(30); var days = _days[0]; var setDays = _days[1];
  var _st = useState(null); var st = _st[0]; var setSt = _st[1];
  var _loading = useState(false); var loading = _loading[0]; var setLoading = _loading[1];
  var _cluster = useState(null); var cluster = _cluster[0]; var setCluster = _cluster[1];
  var _clustering = useState(false); var clustering = _clustering[0]; var setClustering = _clustering[1];

  var loadStats = function (d) {
    setLoading(true);
    authFetch(API + '/admin/assistant/stats?days=' + d).then(function (r) { return r.json(); })
      .then(function (data) { setLoading(false); if (data && !data.error) setSt(data); else if (showToast) showToast((data && data.error) || '불러오기 실패', 'err'); })
      .catch(function () { setLoading(false); if (showToast) showToast('서버 오류', 'err'); });
  };
  var loadClusterCache = function () {
    authFetch(API + '/admin/assistant/cluster').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.cache) setCluster(d.cache); }).catch(function () {});
  };
  useEffect(function () { loadStats(days); }, [days]);
  useEffect(function () { loadClusterCache(); }, []);

  var runCluster = function () {
    if (clustering) return;
    setClustering(true);
    authFetch(API + '/admin/assistant/cluster', { method: 'POST', body: JSON.stringify({ days: days }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        setClustering(false);
        if (d && d.clusters) { setCluster(d); if (showToast) showToast('주제 분석 완료'); }
        else if (showToast) showToast((d && d.error) || '분석 실패', 'err');
      }).catch(function () { setClustering(false); if (showToast) showToast('서버 오류', 'err'); });
  };

  var fb = (st && st.feedback) || { up: 0, down: 0, none: 0 };
  var maxOf = function (arr, key) { var m = 0; (arr || []).forEach(function (r) { if (r[key] > m) m = r[key]; }); return m; };
  var actionColor = function (a) { return a === 'KB보강' ? '#dc2626' : (a === 'FAQ가이드' ? '#2563eb' : '#16a34a'); };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
        <span style={{ fontSize: 13, color: '#64748b' }}>기간</span>
        {[7, 30, 90].map(function (d) {
          return <button key={d} onClick={function () { setDays(d); }} style={{ padding: '5px 14px', borderRadius: 8, fontSize: 13, fontWeight: days === d ? 700 : 500, border: '1px solid ' + (days === d ? '#1B3A5C' : '#d5dde8'), background: days === d ? '#1B3A5C' : '#fff', color: days === d ? '#fff' : '#475569', cursor: 'pointer' }}>{d}일</button>;
        })}
        {loading && <span style={{ fontSize: 12, color: '#94a3b8' }}>불러오는 중…</span>}
        <div style={{ flex: 1 }} />
        <span style={{ fontSize: 13, color: '#334155' }}>총 <b style={{ color: '#1B3A5C', fontSize: 16 }}>{st ? st.total : 0}</b>건 질문</span>
      </div>

      {!st ? null : st.total === 0 ? (
        <div style={{ color: '#94a3b8', fontSize: 14, textAlign: 'center', padding: 40 }}>이 기간에 쌓인 질문이 없습니다.</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {/* 피드백 */}
          <Card title="답변 만족도 (👍 / 👎 / 무응답)">
            <Bar label="👍 도움됨" value={fb.up} max={st.total} color="#16a34a" labelW={90} />
            <Bar label="👎 아쉬움" value={fb.down} max={st.total} color="#dc2626" labelW={90} />
            <Bar label="무응답" value={fb.none} max={st.total} color="#94a3b8" labelW={90} />
            {fb.down > 0 && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 6 }}>👎 답변은 아래 "개선 필요" 목록에서 KB 보강 대상으로 확인하세요.</div>}
          </Card>

          {/* 역할별 */}
          <Card title="역할별 질문">
            {st.byRole.map(function (r) { return <Bar key={r.role} label={r.role} value={r.count} max={maxOf(st.byRole, 'count')} labelW={110} />; })}
          </Card>

          {/* 업체별 — 사용자 요청 핵심 */}
          <Card title="업체별 질문 TOP (누가 많이 묻나)">
            {st.byCompany.length === 0 ? <div style={{ fontSize: 12, color: '#94a3b8' }}>업체 정보 없음</div>
              : st.byCompany.map(function (r) { return <Bar key={r.companyId} label={r.name} value={r.count} max={maxOf(st.byCompany, 'count')} color="#7c3aed" />; })}
          </Card>

          {/* 화면별 */}
          <Card title="화면(page)별 질문 — 어디서 막히나">
            {st.byPage.slice(0, 10).map(function (r, i) { return <Bar key={i} label={r.page} value={r.count} max={maxOf(st.byPage, 'count')} color="#0891b2" />; })}
          </Card>

          {/* 정확 중복 TOP */}
          <Card title="자주 묻는 질문 TOP (정확 일치)">
            <div style={{ fontSize: 11, color: '#94a3b8', marginBottom: 8 }}>표기가 조금만 달라도 따로 집계됩니다. 뜻이 같은 질문은 아래 "AI 주제 분석"으로 묶어 보세요.</div>
            {st.topQuestions.map(function (r, i) { return <Bar key={i} label={r.question} value={r.count} max={maxOf(st.topQuestions, 'count')} labelW={200} color="#1B3A5C" />; })}
          </Card>

          {/* 일별 추이 */}
          <Card title="일별 추이">
            {st.byDay.map(function (r) { return <Bar key={r.date} label={r.date.slice(5)} value={r.count} max={maxOf(st.byDay, 'count')} labelW={54} color="#64748b" />; })}
          </Card>

          {/* 개선 필요 (👎) — 전체폭 */}
          <div style={{ gridColumn: '1 / span 2' }}>
            <Card title={'개선 필요 — 👎 받은 답변 (' + st.recentDown.length + ')'}>
              {st.recentDown.length === 0 ? <div style={{ fontSize: 12, color: '#94a3b8' }}>👎 받은 답변이 없습니다.</div>
                : st.recentDown.map(function (m) {
                  return (
                    <div key={m.id} style={{ borderTop: '1px solid #f1f5f9', padding: '8px 0' }}>
                      <div style={{ fontSize: 13, fontWeight: 700, color: '#dc2626' }}>Q. {m.question}</div>
                      <div style={{ fontSize: 12, color: '#475569', marginTop: 3, whiteSpace: 'pre-wrap' }}>A. {m.answer}</div>
                      <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 3 }}>{m.role} · {m.page || '화면 미상'} · {String(m.created_at || '').slice(0, 16)}</div>
                    </div>
                  );
                })}
            </Card>
          </div>

          {/* AI 주제 군집화 — 전체폭 */}
          <div style={{ gridColumn: '1 / span 2' }}>
            <Card title="AI 주제 분석 — 뜻이 같은 질문을 묶어 진짜 FAQ 추출">
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 10 }}>
                <button onClick={runCluster} disabled={clustering} style={{ padding: '8px 18px', border: 'none', borderRadius: 8, background: clustering ? '#b6c2d4' : '#7c3aed', color: '#fff', fontWeight: 700, cursor: clustering ? 'default' : 'pointer' }}>{clustering ? '분석 중… (Haiku)' : '🤖 최근 질문 주제별 분석'}</button>
                {cluster && <span style={{ fontSize: 12, color: '#64748b' }}>
                  {cluster.analyzed}건 분석{cluster.truncated ? (' (기간 내 ' + cluster.totalInWindow + '건 중 최근 ' + cluster.analyzed + '건만)') : ''}
                  {cluster.generatedAt ? ' · ' + String(cluster.generatedAt).replace('T', ' ').slice(0, 16) : ''}
                </span>}
              </div>
              {!cluster ? <div style={{ fontSize: 12, color: '#94a3b8' }}>버튼을 누르면 최근 질문을 주제별로 묶습니다. (질문 시점에 이미 AI로 처리된 데이터 — 추가 유출 없음)</div>
                : (cluster.clusters || []).length === 0 ? <div style={{ fontSize: 12, color: '#94a3b8' }}>묶을 질문이 없습니다.</div>
                : (
                  <div>
                    {cluster.clusters.map(function (c, i) {
                      return (
                        <div key={i} style={{ borderTop: '1px solid #f1f5f9', padding: '10px 0', display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                          <div style={{ minWidth: 44, textAlign: 'center' }}>
                            <div style={{ fontSize: 20, fontWeight: 800, color: '#7c3aed' }}>{c.count}</div>
                            <div style={{ fontSize: 10, color: '#94a3b8' }}>건</div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div style={{ fontSize: 14, fontWeight: 700, color: '#1f2937' }}>{c.theme}
                              <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 700, color: '#fff', background: actionColor(c.action), padding: '2px 8px', borderRadius: 10 }}>{c.action}</span>
                            </div>
                            {(c.examples || []).map(function (ex, j) { return <div key={j} style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>· {ex}</div>; })}
                          </div>
                        </div>
                      );
                    })}
                    <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 10 }}>
                      <b style={{ color: '#dc2626' }}>KB보강</b> = utils/assistantKb.js 에 내용 추가 · <b style={{ color: '#2563eb' }}>FAQ가이드</b> = '가이드 관리' 탭에서 스크린샷 등록 · <b style={{ color: '#16a34a' }}>정상</b> = 이미 잘 답변 중
                    </div>
                  </div>
                )}
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminFaqStats;
